import { useTranslation } from "react-i18next";
import { Employee } from "../types/employees";
import EmployeeSummary from "./EmployeeSummary";
import Modal from "./Modal";

type EmployeeDetailsModalProps = {
  employee: Employee | null;
  isOpen: boolean;
  onClose: () => void;
};

/**
 * Reusable read-only view of a customer's key details. Used from the staff
 * table and the episode intake flow.
 */
function EmployeeDetailsModal({
  employee,
  isOpen,
  onClose,
}: EmployeeDetailsModalProps) {
  const { t } = useTranslation();

  if (!employee) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      titleId="employee-details-title"
      title={employee.fullName}
      description={t("Customer details")}
    >
      <EmployeeSummary employee={employee} showFullName />
    </Modal>
  );
}

export default EmployeeDetailsModal;
